import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import WhySection from '../components/WhySection';
import PriceTable from '../components/PriceTable';
import GallerySection from '../components/GallerySection';
import ManagerSection from '../components/ManagerSection';

const nuruFaqSchema = {
  en: [
    { q: 'What is Nuru massage in Sukhumvit?', a: 'Nuru massage in Sukhumvit at Bunny Boy Massage is a premium sensual massage experience. Our services include Body Scrub, Spa Hot Tub Onsen (whirlpool bath), Aromatherapy Massage, and Kassai (Prostate) Massage. It is considered one of the most intimate and relaxing massage styles available in Sukhumvit, Bangkok.' },
    { q: 'How much does a Nuru massage cost in Sukhumvit?', a: 'At Bunny Boy Massage, Nuru massage Sukhumvit prices are: Standard Room 60 minutes for THB 2,000 (Aromatherapy Massage + Kassai Massage), Standard Room 90 minutes for THB 2,500 (Body Scrub + Aromatherapy Massage + Kassai Massage), and Luxury Room 90 minutes for THB 3,200 (Spa Hot Tub Onsen + Body Scrub + Aromatherapy Massage + Kassai Massage). We accept Thai Baht, US Dollars, and Korean Won.' },
    { q: 'What is the difference between Nuru massage and regular massage?', a: 'Nuru massage Sukhumvit at Bunny Boy Massage differs significantly from regular massage. Our sessions include specialized services such as Body Scrub, Spa Hot Tub Onsen, Aromatherapy Massage with premium oils, and Kassai (Prostate) Massage — a combination that creates a uniquely relaxing and intimate experience unavailable at ordinary massage parlors.' },
    { q: 'Is Nuru massage safe and hygienic?', a: 'Absolutely. At Bunny Boy Massage, we maintain the highest hygiene standards for all Nuru massage Sukhumvit sessions. Each room is thoroughly sanitized between sessions, fresh towels and linens are provided for every client, and our masseuses follow strict health and cleanliness protocols. Our Spa Hot Tub Onsen is cleaned and refilled for each guest.' },
    { q: 'How do I book a Nuru massage at Bunny Boy Massage?', a: 'You can book your Nuru massage Sukhumvit session through LINE (ID: bunnyboybkk), WhatsApp (ID: bunnyboybkk), or by calling 081-110-3766. We recommend booking in advance as Nuru massage is our most popular service and preferred time slots fill quickly.' },
    { q: 'Where is Bunny Boy Massage located?', a: 'Bunny Boy Massage is located at 3/15, 4th Floor, Sukhumvit 71 Rd, Khwaeng Phra Khanong Nuea, Watthana, Bangkok 10110. We are just a 5-minute walk from BTS Phra Khanong Station, making us one of the most accessible Nuru massage parlors in Sukhumvit.' },
    { q: 'What should I expect during a Nuru massage session?', a: 'During your Nuru massage Sukhumvit session at Bunny Boy Massage, you will first be greeted and choose your masseuse. Depending on your package, you may enjoy a Spa Hot Tub Onsen (whirlpool bath), followed by a Body Scrub to exfoliate and refresh your skin. The session continues with a relaxing Aromatherapy Massage using premium oils, and concludes with a Kassai Massage for deep satisfaction and release.' },
    { q: 'What are the opening hours?', a: 'Bunny Boy Massage is open daily from 10:00 AM to midnight (00:00 AM). For Nuru massage in Sukhumvit, we recommend booking at least 30 minutes in advance to ensure your preferred masseuse is available.' },
  ],
  zh: [
    { q: '什么是曼谷变相按摩？和普通按摩有什么区别？', a: '曼谷变相按摩是Bunny Boy Massage提供的高端感官按摩体验。我们的服务包括身体磨砂、温泉浴（Spa Hot Tub Onsen）、芳香精油按摩和卡赛按摩。与普通泰式按摩不同，曼谷变相按摩提供多种专业服务的组合，创造出独一无二的放松和感官体验。Bunny Boy Massage是曼谷素坤逸地区提供最正宗曼谷变相按摩体验的顶级场所。' },
    { q: '曼谷变相按摩的价格是多少？', a: '在Bunny Boy Massage，我们提供多种曼谷变相按摩套餐：标准房间60分钟THB 2,000（芳香精油按摩 + 卡赛按摩），标准房间90分钟THB 2,500（身体磨砂 + 芳香精油按摩 + 卡赛按摩），豪华房间90分钟THB 3,200（温泉浴 + 身体磨砂 + 芳香精油按摩 + 卡赛按摩）。所有套餐均包含独立私人房间和迎宾饮品。我们接受泰铢、人民币、美元和韩元支付。' },
    { q: '曼谷变相按摩安全卫生吗？', a: '绝对安全。Bunny Boy Massage对每一次曼谷变相按摩服务都执行最严格的卫生标准。每间房间在每次使用后都经过全面彻底消毒，所有毛巾和床单均为一次性使用或经高温消毒处理。温泉浴设施每次使用后都会彻底清洁和更换水源。' },
    { q: '第一次体验曼谷变相按摩需要注意什么？', a: '首次体验曼谷变相按摩时，请放松心情享受整个过程。建议体验前后多喝水保持水分。我们的按摩师会全程引导您，确保您的曼谷变相按摩体验自然舒适。首次体验的客人建议选择90分钟套餐，充足的时间让您可以更完整地享受身体磨砂、芳香精油按摩和卡赛按摩的每一个环节。' },
    { q: '如何预约曼谷变相按摩？', a: '您可以通过LINE（ID: bunnyboybkk）、WhatsApp（ID: bunnyboybkk）或致电081-110-3766预约曼谷变相按摩。我们建议提前预约，因为曼谷变相按摩是Bunny Boy Massage最受欢迎的服务之一，热门时段经常被预约满。通过LINE或WhatsApp预约曼谷变相按摩还可以提前浏览我们的按摩师阵容。' },
    { q: 'Bunny Boy Massage的曼谷变相按摩在哪里？', a: 'Bunny Boy Massage位于曼谷素坤逸71路3/15号4楼，距BTS Phra Khanong站仅5分钟步行路程。我们的4楼位置确保所有前来体验曼谷变相按摩的客人享有最大程度的隐私和安静环境。无论您从曼谷市中心还是素坤逸沿线酒店出发，乘BTS、出租车或Grab都可轻松到达我们的曼谷变相按摩场所。' },
    { q: '曼谷变相按摩的体验流程是怎样的？', a: '完整的曼谷变相按摩体验包含以下阶段：第一步到达后选择您心仪的按摩师；第二步享受温泉浴放松身心（豪华房间）；第三步身体磨砂去角质（90分钟以上套餐）；第四步芳香精油按摩深度放松；第五步卡赛按摩带来极致满足。整个曼谷变相按摩过程持续60-120分钟不等。' },
    { q: '曼谷变相按摩的营业时间？', a: 'Bunny Boy Massage每天营业时间为上午10:00至凌晨00:00，全年无休，包括节假日和周末。我们建议在下午和晚间高峰时段提前预约曼谷变相按摩，以确保您心仪的按摩师有档期。中午时段预约曼谷变相按摩通常更容易获得即时服务。' },
    { q: '为什么选择Bunny Boy Massage的曼谷变相按摩而不是其他按摩店？', a: 'Bunny Boy Massage的曼谷变相按摩在素坤逸地区享有最高口碑，这得益于我们在三个方面的核心优势：第一，我们提供身体磨砂、温泉浴、芳香精油按摩和卡赛按摩的完整专业服务组合；第二，每位曼谷变相按摩师都经过严格专业培训，技术水平远超行业标准；第三，我们的硬件设施堪称一流，豪华房间配备Spa Hot Tub Onsen温泉浴设施。此外，位于4楼的隐私设计、友好专业的接待服务和便捷的素坤逸中心位置，让Bunny Boy Massage成为体验曼谷变相按摩的不二之选。' },
  ],
  ko: [
    { q: '방콕 짭까사이란 정확히 무엇인가요?', a: '방콕 짭까사이는 Bunny Boy Massage에서 제공하는 프리미엄 감각 마사지 경험입니다. 서비스에는 바디스크럽, 스파 핫터브 온센(월풀 바스), 아로마테라피 마사지, 카사이(전립선) 마사지가 포함됩니다. 전문 교육을 이수한 20대 태국 마사지사가 방콕에서 가장 정통적인 방콕 짭까사이 경험을 제공합니다.' },
    { q: '방콕 짭까사이 가격은 얼마인가요?', a: 'Bunny Boy Massage의 방콕 짭까사이 가격은 다음과 같습니다: 스탠다드 룸 60분 THB 2,000 (아로마테라피 마사지 + 카사이 마사지), 스탠다드 룸 90분 THB 2,500 (바디스크럽 + 아로마테라피 마사지 + 카사이 마사지), 럭셔리 룸 90분 THB 3,200 (스파 핫터브 온센 + 바디스크럽 + 아로마테라피 마사지 + 카사이 마사지)입니다. 모든 가격에 프라이빗 룸과 무료 웰컴 음료가 포함됩니다. 숨겨진 추가 비용은 일절 없으며, 바트/한화/달러 결제가 모두 가능합니다.' },
    { q: '방콕 짭까사이와 일반 태국 마사지의 차이점은?', a: '방콕 짭까사이와 일반 태국 마사지는 본질적으로 완전히 다른 경험입니다. 일반 태국 마사지는 손과 팔꿈치를 사용한 근육 이완과 스트레칭에 초점을 맞추지만, 방콕 짭까사이는 바디스크럽, 스파 핫터브 온센, 아로마테라피 마사지, 카사이 마사지를 결합한 종합적인 프리미엄 감각 체험입니다. 이러한 전문 서비스 조합이 다른 어떤 마사지 방식으로도 절대 재현할 수 없는 방콕 짭까사이만의 독보적인 경험을 선사합니다.' },
    { q: '방콕 짭까사이는 안전하고 프라이버시가 보장되나요?', a: '네, Bunny Boy Massage의 방콕 짭까사이는 절대적으로 안전합니다. 모든 방콕 짭까사이 룸은 완전히 프라이빗하며 개별 잠금장치가 되어 있습니다. 방콕 짭까사이 마사지사는 정기적으로 건강 검진을 받으며, 모든 룸은 매 서비스 후 철저히 소독됩니다. 스파 핫터브 온센도 매 고객 후 완전히 세척됩니다. 4층의 별도 입구가 방콕 짭까사이 고객의 완벽한 프라이버시를 보장합니다.' },
    { q: '방콕 짭까사이 예약은 어떻게 하나요?', a: '방콕 짭까사이 예약은 LINE (ID: bunnyboybkk), WhatsApp (ID: bunnyboybkk), 또는 전화 081-110-3766로 가능합니다. 방콕 짭까사이는 Bunny Boy Massage에서 가장 인기 있는 서비스이므로, 특히 저녁 피크 시간대(오후 7시~11시)에는 반드시 사전 예약이 필요합니다. LINE이나 WhatsApp으로 방콕 짭까사이를 예약하시면 사전에 마사지사 라인업을 확인하실 수 있습니다.' },
    { q: '방콕 짭까사이에서 마사지사를 직접 선택할 수 있나요?', a: '물론입니다! Bunny Boy Massage에서는 방콕 짭까사이 고객이 직접 마사지사를 선택할 수 있습니다. 도착하시면 엄선된 20대 아름다운 태국 마사지사 라인업을 직접 보시고 마음에 드는 분을 선택하실 수 있습니다. 모든 방콕 짭까사이 마사지사는 아로마테라피, 카사이 마사지, 바디스크럽 등 전문 기술에 대한 집중 교육을 이수했습니다. 원하시는 스타일을 미리 말씀해 주시면 최적의 마사지사를 추천해 드립니다.' },
    { q: '처음 방콕 짭까사이를 체험할 때 어떤 준비가 필요한가요?', a: '특별한 준비는 필요 없습니다. 편안한 마음으로 오시면 됩니다. 도착하시면 마사지사가 전체 과정을 안내해 드립니다. 처음이시라면 90분 스탠다드 룸 코스(THB 2,500)를 추천합니다 — 바디스크럽, 아로마테라피 마사지, 카사이 마사지를 모두 경험하실 수 있습니다.' },
    { q: '방콕 짭까사이 영업시간과 최적 방문 시간은?', a: 'Bunny Boy Massage는 매일 오전 10:00부터 자정(00:00)까지 영업하며, 주말과 공휴일 포함 연중무휴입니다. 방콕 짭까사이는 오후와 저녁 시간대가 가장 인기 있으므로, 피크 타임에는 반드시 사전 예약을 권장합니다. 점심~오후 시간대(오후 12시~4시)에 방콕 짭까사이를 예약하시면 비교적 여유롭게 서비스를 받으실 수 있습니다.' },
  ],
};

const galleryImages = [
  { src: '/gallery-lounge1.jpg', alt: 'Bunny Boy Massage Sukhumvit Lounge Area' },
  { src: '/gallery-lounge2.jpg', alt: 'Happy Ending Massage Sukhumvit Bar Counter' },
  { src: '/gallery-reception.jpg', alt: 'Bunny Boy Massage Reception Desk Sukhumvit' },
  { src: '/gallery-interior1.jpg', alt: 'Massage Parlor Interior Sukhumvit Bangkok' },
  { src: '/gallery-interior2.jpg', alt: 'Luxury Massage Lounge Sukhumvit' },
  { src: '/gallery-interior3.jpg', alt: 'Bunny Boy Massage Premium Reception' },
  { src: '/gallery-lounge3.jpg', alt: 'VIP Lounge Bar Sukhumvit Massage' },
  { src: '/gallery-lounge4.jpg', alt: 'Private Waiting Area Happy Ending Massage' },
  { src: '/gallery-room2.jpg', alt: 'Happy Ending Massage Room Sukhumvit' },
  { src: '/gallery-room3.jpg', alt: 'Premium Massage Room Bangkok Sukhumvit' },
  { src: '/gallery-shower.jpg', alt: 'Private Shower Room Bunny Boy Massage' },
  { src: '/gallery-room1.jpg', alt: 'VIP Room Bunny Boy Massage Sukhumvit' },
];

const managers = [
  { name: 'Nana', age: 'Age 23 · 165cm', image: '/masseuse-new1.jpg' },
  { name: 'Yuri', age: 'Age 22 · 163cm', image: '/masseuse-new2.jpg' },
  { name: 'Bee', age: 'Age 22 · 162cm', image: '/masseuse-14.jpg' },
  { name: 'Kwan', age: 'Age 23 · 165cm', image: '/masseuse-15.jpg' },
  { name: 'Aom', age: 'Age 21 · 160cm', image: '/masseuse-16.jpg' },
  { name: 'Fah', age: 'Age 22 · 163cm', image: '/masseuse-17.jpg' },
  { name: 'Ploy', age: 'Age 23 · 165cm', image: '/gallery-staff.jpg' },
  { name: 'Nong', age: 'Age 22 · 160cm', image: '/gallery-staff2.jpg' },
  { name: 'Fern', age: 'Age 24 · 163cm', image: '/gallery-staff3.jpg' },
  { name: 'Bam', age: 'Age 21 · 158cm', image: '/gallery-staff4.jpg' },
  { name: 'Mint', age: 'Age 22 · 162cm', image: '/masseuse-5.jpg' },
  { name: 'Pim', age: 'Age 23 · 160cm', image: '/masseuse-6.jpg' },
  { name: 'Nan', age: 'Age 21 · 164cm', image: '/masseuse-7.jpg' },
  { name: 'Som', age: 'Age 24 · 158cm', image: '/masseuse-8.jpg' },
  { name: 'Joy', age: 'Age 22 · 161cm', image: '/masseuse-9.jpg' },
  { name: 'Mew', age: 'Age 23 · 163cm', image: '/masseuse-10.jpg' },
  { name: 'Dao', age: 'Age 21 · 159cm', image: '/masseuse-11.jpg' },
  { name: 'Pear', age: 'Age 22 · 165cm', image: '/masseuse-12.jpg' },
  { name: 'Oil', age: 'Age 23 · 160cm', image: '/masseuse-13.jpg' },
];

const priceData = {
  standard: {
    title: 'Standard Room',
    packages: [
      { duration: '60 minutes', price: '฿2,000', items: ['Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '90 minutes', price: '฿2,500', items: ['Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '120 minutes', price: '฿3,000', items: ['Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
    ],
  },
  luxury: {
    title: 'Luxury Room',
    packages: [
      { duration: '60 minutes', price: '฿2,700', items: ['Spa Hot Tub Onsen', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '90 minutes', price: '฿3,200', items: ['Spa Hot Tub Onsen', 'Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '120 minutes', price: '฿3,700', items: ['Spa Hot Tub Onsen', 'Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
    ],
  },
  extras: {
    title: 'Extra Option',
    items: [
      { name: 'Stocking', price: '฿300' },
      { name: 'Cosplay', price: '฿300' },
      { name: 'Body to Body', price: '฿500' },
    ],
  },
};

const priceDataZh = {
  standard: {
    title: '标准房间',
    packages: [
      { duration: '60 分钟', price: '฿2,000', items: ['芳香精油按摩', '卡赛按摩'] },
      { duration: '90 分钟', price: '฿2,500', items: ['身体磨砂', '芳香精油按摩', '卡赛按摩'] },
      { duration: '120 分钟', price: '฿3,000', items: ['身体磨砂', '芳香精油按摩', '卡赛按摩'] },
    ],
  },
  luxury: {
    title: '豪华房间',
    packages: [
      { duration: '60 分钟', price: '฿2,700', items: ['温泉浴', '芳香精油按摩', '卡赛按摩'] },
      { duration: '90 分钟', price: '฿3,200', items: ['温泉浴', '身体磨砂', '芳香精油按摩', '卡赛按摩'] },
      { duration: '120 分钟', price: '฿3,700', items: ['温泉浴', '身体磨砂', '芳香精油按摩', '卡赛按摩'] },
    ],
  },
  extras: {
    title: '附加选项',
    items: [
      { name: '丝袜 (Stocking)', price: '฿300' },
      { name: '角色扮演 (Cosplay)', price: '฿300' },
      { name: '身体推油 (Body to Body)', price: '฿500' },
    ],
  },
};

const sectionLabels = {
  en: {
    guideTitle: 'The Complete Guide to Nuru Massage in Sukhumvit',
    guideSubtitle: 'Everything You Need to Know',
    whatTitle: 'What Is Nuru Massage Sukhumvit?',
    experienceTitle: 'The Bunny Boy Nuru Massage Experience',
    experienceSubtitle: 'A Sensual Journey Like No Other',
    typesTitle: 'Nuru Massage Sukhumvit Packages',
    typesSubtitle: 'Choose Your Perfect Session',
    gelTitle: 'The Spa Hot Tub Onsen Experience',
    gelSubtitle: 'Premium Whirlpool Bath Relaxation',
    expectTitle: 'What to Expect at Your Nuru Massage Session',
    expectSubtitle: 'Your Visit, Step by Step',
    tipsTitle: 'Tips for Your First Nuru Massage in Sukhumvit',
    locationTitle: 'Visit Bunny Boy Massage Sukhumvit',
    locationSubtitle: 'Conveniently Located in the Heart of Bangkok',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Nuru Massage Sukhumvit',
    ctaTitle: 'Ready to Experience the Best Nuru Massage in Sukhumvit?',
    ctaSubtitle: 'Book your session today and discover why Bunny Boy Massage is Bangkok\'s top-rated Nuru massage destination in Sukhumvit.',
    ctaButton: 'Book Your Nuru Massage Now',
    priceTitle: 'Nuru Massage Sukhumvit Price List',
    priceSubtitle: 'Transparent Pricing — No Hidden Fees',
    galleryTitle: 'Our Luxurious Facilities',
    gallerySubtitle: 'Step Inside Bunny Boy Massage Sukhumvit',
    managerTitle: 'Meet Our Beautiful Masseuses',
    managerSubtitle: 'Hand-Selected Thai Therapists',
  },
  zh: {
    guideTitle: '曼谷变相按摩完全指南 — 素坤逸最正宗的日式感官体验',
    guideSubtitle: '曼谷变相按摩 · 您需要知道的一切',
    whatTitle: '什么是曼谷变相按摩？',
    experienceTitle: 'Bunny Boy Massage 曼谷变相按摩体验',
    experienceSubtitle: '曼谷变相按摩 · 独一无二的感官之旅',
    typesTitle: '曼谷变相按摩套餐',
    typesSubtitle: '选择您的曼谷变相按摩体验',
    gelTitle: '曼谷变相按摩 · 温泉浴Spa Hot Tub体验',
    gelSubtitle: '曼谷变相按摩 · 豪华温泉浴设施',
    expectTitle: '曼谷变相按摩体验流程',
    expectSubtitle: '您的曼谷变相按摩到访步骤',
    tipsTitle: '首次曼谷变相按摩小贴士',
    locationTitle: '曼谷变相按摩 · Bunny Boy Massage 素坤逸',
    locationSubtitle: '曼谷变相按摩 · 素坤逸中心便利位置',
    faqTitle: '曼谷变相按摩 · 常见问题解答',
    faqSubtitle: '曼谷变相按摩',
    ctaTitle: '准备好体验曼谷最好的变相按摩了吗？',
    ctaSubtitle: '立即预约您的曼谷变相按摩，了解为什么Bunny Boy Massage是素坤逸最受好评的曼谷变相按摩场所。',
    ctaButton: '立即预约曼谷变相按摩',
    priceTitle: '曼谷变相按摩价格表',
    priceSubtitle: '透明定价 — 无隐藏费用',
    galleryTitle: '我们的豪华设施',
    gallerySubtitle: '走进曼谷 Bunny Boy Massage',
    managerTitle: '遇见我们美丽的按摩师',
    managerSubtitle: '精心挑选的泰国按摩师',
  },
  ko: {
    guideTitle: '방콕 짭까사이 완벽 가이드 — 수쿰빗 최고의 정통 방콕 짭까사이 체험',
    guideSubtitle: '방콕 짭까사이 · 알아야 할 모든 것',
    whatTitle: '방콕 짭까사이란? 기원·기법·효과 상세 안내',
    experienceTitle: 'Bunny Boy 방콕 짭까사이 체험',
    experienceSubtitle: '방콕 짭까사이 · 비할 데 없는 감각적 여정',
    typesTitle: '방콕 짭까사이 코스 종류 & 가격',
    typesSubtitle: '나에게 맞는 방콕 짭까사이 코스 선택',
    gelTitle: '방콕 짭까사이 · 스파 핫터브 온센 체험',
    gelSubtitle: '방콕 짭까사이 · 프리미엄 월풀 바스 시설',
    expectTitle: '방콕 짭까사이 체험 과정 — 단계별 상세 안내',
    expectSubtitle: '방콕 짭까사이 · 방문 가이드',
    tipsTitle: '첫 방콕 짭까사이 체험을 위한 실용 팁',
    locationTitle: '방콕 짭까사이 오시는 길 — Bunny Boy Massage 위치',
    locationSubtitle: '방콕 짭까사이 · 수쿰빗 중심부의 편리한 위치',
    faqTitle: '방콕 짭까사이 자주 묻는 질문',
    faqSubtitle: '방콕 짭까사이 · 궁금한 모든 것',
    ctaTitle: '최고의 방콕 짭까사이 체험을 준비하세요',
    ctaSubtitle: '지금 예약하고 Bunny Boy Massage가 방콕 짭까사이 No.1인 이유를 직접 확인하세요. 매일 10AM-자정 영업.',
    ctaButton: '방콕 짭까사이 지금 예약하기',
    priceTitle: '방콕 짭까사이 가격표',
    priceSubtitle: '투명한 가격 — 추가 비용 없음',
    galleryTitle: '럭셔리 시설 안내',
    gallerySubtitle: '수쿰빗 Bunny Boy Massage 내부 시설',
    managerTitle: '미모의 매니저 라인업',
    managerSubtitle: '엄선된 전문 매니저',
  },
};

const bodyContent = {
  en: {
    what: [
      'Nuru massage Sukhumvit at Bunny Boy Massage is the ultimate premium sensual massage experience in Bangkok. Our carefully curated services include Body Scrub, Spa Hot Tub Onsen (whirlpool bath), Aromatherapy Massage with premium essential oils, and Kassai (Prostate) Massage — a combination designed to deliver complete relaxation and deep satisfaction.',
      'Unlike any other massage style available in Bangkok, Nuru massage in Sukhumvit at Bunny Boy Massage combines multiple specialized treatments into one seamless experience. From the invigorating Body Scrub that refreshes your skin to the soothing warmth of the Spa Hot Tub Onsen, every element is designed to heighten your senses and prepare your body for the deeply relaxing Aromatherapy Massage and satisfying Kassai Massage that follow.',
      'What makes Nuru massage Sukhumvit at Bunny Boy Massage exceptional is our commitment to quality. We use only premium aromatherapy oils, maintain immaculate Spa Hot Tub Onsen facilities, and our masseuses undergo specialized training to deliver an experience that has made Bunny Boy Massage the top-rated destination in Sukhumvit.',
    ],
    experience: [
      'From the moment you arrive at Bunny Boy Massage for your Nuru massage Sukhumvit session, every detail is designed to maximize your pleasure. Our private rooms feature comfortable massage beds, rainfall showers, ambient mood lighting, and temperature-controlled environments — essential elements for the perfect relaxation experience. Luxury rooms also include a private Spa Hot Tub Onsen.',
      'Each Nuru massage Sukhumvit session is a carefully choreographed journey of relaxation. For Luxury Room packages, you begin with a warm soak in the Spa Hot Tub Onsen, where the whirlpool jets ease tension from your muscles. For 90-minute and longer sessions, a thorough Body Scrub follows, exfoliating and refreshing your skin.',
      'The Aromatherapy Massage is performed with premium essential oils, as your masseuse applies expert techniques to release tension throughout your body. The session builds toward the Kassai Massage, delivering deep satisfaction and a sense of complete renewal that will leave you feeling refreshed and revitalized.',
    ],
    gel: [
      'The Spa Hot Tub Onsen at Bunny Boy Massage is a luxurious whirlpool bath experience available in our Luxury Room packages. Unlike ordinary bathtubs found at other Sukhumvit massage parlors, our Spa Hot Tub Onsen features powerful hydro-massage jets that target key muscle groups, warm circulating water maintained at the perfect temperature, and a spacious design for ultimate comfort.',
      'Soaking in the Spa Hot Tub Onsen before your massage opens your pores, relaxes tight muscles, and prepares your body for the Aromatherapy Massage and Kassai Massage that follow. The warm water circulation promotes blood flow and releases tension, creating the ideal foundation for a deeply satisfying Nuru massage Sukhumvit experience. Many of our returning clients specifically choose the Luxury Room for the Spa Hot Tub Onsen alone.',
    ],
    steps: [
      { step: '01', title: 'Arrival & Selection', desc: 'Upon arriving at our Sukhumvit Nuru massage parlor, you will be warmly greeted and offered a refreshment. Browse our lineup of beautiful, specially trained masseuses and choose your preferred companion.' },
      { step: '02', title: 'Spa Hot Tub Onsen', desc: 'For Luxury Room packages, your Nuru massage Sukhumvit session begins with a relaxing soak in the Spa Hot Tub Onsen. The warm whirlpool jets ease your muscles and prepare your body for the treatments ahead.' },
      { step: '03', title: 'Body Scrub', desc: 'For 90-minute and longer sessions, enjoy a thorough Body Scrub that exfoliates and refreshes your skin, removing dead cells and leaving you feeling revitalized and ready for the massage.' },
      { step: '04', title: 'Aromatherapy & Kassai Massage', desc: 'The core of your Nuru massage Sukhumvit session — your masseuse performs a deeply relaxing Aromatherapy Massage with premium oils, followed by the Kassai Massage for ultimate satisfaction and release.' },
      { step: '05', title: 'Refreshing Finish', desc: 'After your Nuru massage session, enjoy a warm shower. A hot towel and refreshment await you as you return to reality from your Sukhumvit Nuru massage experience.' },
    ],
    tips: [
      { icon: '🛁', text: 'Choose the Luxury Room to enjoy the Spa Hot Tub Onsen — the whirlpool bath is the perfect start to your Nuru massage experience.' },
      { icon: '💎', text: 'Remove all jewelry before your session to avoid any issues during the Body Scrub and massage treatments.' },
      { icon: '⏰', text: 'Book at least 30 minutes in advance to ensure the best Nuru massage Sukhumvit experience and your preferred masseuse.' },
      { icon: '🧴', text: 'Don\'t apply lotion or body products before arriving — clean skin gets the most benefit from the Body Scrub and Aromatherapy Massage.' },
      { icon: '💧', text: 'Stay hydrated — drink water before and after your session for the best results from your Nuru massage experience.' },
      { icon: '📱', text: 'Book via LINE (bunnyboybkk) or WhatsApp (bunnyboybkk) to secure your preferred masseuse and time slot.' },
    ],
    location: [
      'Finding the best Nuru massage in Sukhumvit is easy — Bunny Boy Massage is located on Sukhumvit 71 Road, just a 5-minute walk from BTS Phra Khanong Station. Our 4th-floor location ensures complete privacy and discretion for all guests seeking the ultimate Nuru massage Sukhumvit experience.',
    ],
  },
  zh: {
    what: [
      '曼谷变相按摩是Bunny Boy Massage提供的顶级感官按摩体验，在曼谷素坤逸地区享有极高声誉。我们的服务包括身体磨砂、温泉浴（Spa Hot Tub Onsen）、芳香精油按摩和卡赛按摩——精心设计的服务组合，旨在为每一位客人带来完全的放松和深度满足。Bunny Boy Massage是曼谷素坤逸地区提供最正宗曼谷变相按摩的首选场所。',
      '与曼谷市面上的普通按摩截然不同，曼谷变相按摩将多种专业服务融合为一个完整的感官体验。从令肌肤焕然一新的身体磨砂，到温暖舒适的温泉浴放松，再到使用高级精油的芳香按摩和带来极致满足的卡赛按摩，每一个环节都经过精心设计，层层递进，为您带来无与伦比的享受。',
      '让Bunny Boy Massage的曼谷变相按摩在众多同类服务中脱颖而出的，是我们对品质的极致追求。我们使用最优质的芳香精油，维护一流的温泉浴设施，每一位曼谷变相按摩师都接受过严格的专业培训。这种对品质和专业性的坚持，确保您在Bunny Boy Massage体验的每一次曼谷变相按摩都是真正意义上的顶级享受。',
      '在Bunny Boy Massage，我们的曼谷变相按摩团队由精心挑选的20代年轻美丽女性组成，她们不仅外表出众，更具备深厚的专业功底和细腻的服务意识。每位曼谷变相按摩师在上岗前都必须完成系统培训，涵盖芳香精油按摩技法、卡赛按摩专业技术、身体磨砂手法和客户服务等核心课程。正是这种远超行业标准的严格培训体系，让Bunny Boy Massage的曼谷变相按摩始终保持素坤逸地区最高的服务水准和客户满意度。',
    ],
    experience: [
      '当您走进Bunny Boy Massage准备开始曼谷变相按摩体验时，您就踏入了一个为极致感官享受而精心打造的私密世界。柔和的氛围灯光、淡雅的香薰气息和舒缓的背景音乐在接待区营造出宁静而优雅的氛围，让您在开始曼谷变相按摩之前就感受到身心的深度放松。我们的每一间私人房间都配备了舒适的按摩床、雨淋花洒淋浴系统、可调节氛围灯光和独立温控系统。豪华房间更配备了专属的Spa Hot Tub Onsen温泉浴设施。',
      '豪华房间套餐的曼谷变相按摩体验从温暖的温泉浴开始。Spa Hot Tub Onsen的涡旋水流温柔地按摩您的全身肌肉，释放紧张和疲劳，为接下来的服务做完美准备。90分钟及以上套餐还包含专业的身体磨砂环节，去除角质，让肌肤焕然一新。',
      '芳香精油按摩使用高品质精油，按摩师以专业手法为您进行深度放松，释放全身的紧张和压力。整个体验最终以卡赛按摩达到高潮，带来深度的满足感和全身心的焕然一新。',
      '对于经常出差曼谷的商务人士和来泰国旅游的游客而言，曼谷变相按摩已经成为素坤逸地区最值得尝试的特色体验之一。Bunny Boy Massage的曼谷变相按摩不仅提供顶级的感官享受，更是一次彻底释放身心压力的完美方式。在繁忙的工作或旅途之后，一场90分钟的曼谷变相按摩能够让您的身体从头到脚得到彻底放松。很多回头客表示，在Bunny Boy Massage体验曼谷变相按摩已经成为他们每次来曼谷的固定行程。',
    ],
    gel: [
      'Bunny Boy Massage豪华房间配备的Spa Hot Tub Onsen温泉浴是曼谷变相按摩体验中令人难忘的亮点。与一些普通按摩店的简陋浴缸不同，我们的Spa Hot Tub Onsen拥有强力涡旋按摩水柱，精准针对主要肌肉群进行水流按摩，水温始终保持在最舒适的温度，宽敞的设计确保您的极致舒适体验。',
      '在按摩前浸泡温泉浴能打开毛孔、放松紧绷的肌肉，为接下来的芳香精油按摩和卡赛按摩做最完美的准备。温暖的涡旋水流促进血液循环，释放身体深处的紧张感，为深度满足的曼谷变相按摩体验奠定理想基础。许多回头客专门选择豪华房间，就是为了享受Spa Hot Tub Onsen温泉浴带来的独特放松体验。',
    ],
    steps: [
      { step: '01', title: '到达与选择', desc: '到达Bunny Boy Massage曼谷变相按摩场所时，友好专业的接待人员会热情迎接您并递上迎宾饮品。在轻松的氛围中，浏览我们精心挑选的美丽按摩师阵容，选择最让您心动的那一位。' },
      { step: '02', title: '温泉浴放松', desc: '豪华房间套餐的曼谷变相按摩体验从Spa Hot Tub Onsen温泉浴开始。温暖的涡旋水流温柔地放松您的全身肌肉，为接下来的服务做完美准备。' },
      { step: '03', title: '身体磨砂', desc: '90分钟及以上套餐包含专业的身体磨砂环节。去除角质、刺激血液循环，让您的肌肤焕然一新，为芳香精油按摩做最佳准备。' },
      { step: '04', title: '芳香精油按摩 & 卡赛按摩', desc: '曼谷变相按摩的核心环节——按摩师使用高品质芳香精油进行深度放松按摩，随后以专业的卡赛按摩带来极致满足和完美释放。' },
      { step: '05', title: '清爽收尾', desc: '曼谷变相按摩结束后，享受温暖舒适的淋浴。热毛巾和精心准备的饮品等待着您，帮助您从这次美妙的曼谷变相按摩之旅中慢慢回到现实。' },
    ],
    tips: [
      { icon: '🛁', text: '选择豪华房间套餐享受Spa Hot Tub Onsen温泉浴——涡旋水流按摩是曼谷变相按摩体验的完美开端。' },
      { icon: '💎', text: '体验曼谷变相按摩前请务必摘下所有首饰、手表和贵重物品，以免在身体磨砂和按摩过程中造成不便。' },
      { icon: '⏰', text: '至少提前30分钟预约您的曼谷变相按摩，提前预约才能确保您心仪的按摩师有档期。' },
      { icon: '🧴', text: '到达前不要涂抹乳液、防晒霜或任何身体产品——干净清爽的皮肤能最好地感受身体磨砂和芳香精油按摩的效果。' },
      { icon: '💧', text: '保持充分的水分摄入——体验前后请多喝水，这样能让您的身体更好地享受和恢复。' },
      { icon: '📱', text: '通过LINE (bunnyboybkk)或WhatsApp (bunnyboybkk)提前预约曼谷变相按摩，不仅可以确保您心仪的按摩师有档期，还能提前浏览按摩师阵容做出最满意的选择。' },
    ],
    location: [
      '在曼谷寻找最正宗的曼谷变相按摩？Bunny Boy Massage位于曼谷素坤逸71路，距BTS Phra Khanong站仅5分钟步行路程，是素坤逸地区最便捷的曼谷变相按摩目的地。我们的场所位于4楼，确保每一位前来体验曼谷变相按摩的客人都能享有最大程度的隐私保护和安静舒适的环境。低调优雅的入口设计让您可以完全放心地到访，不必担心任何尴尬或不便。',
      '无论您是常驻曼谷的外籍商务人士、来泰国度假的游客，还是在素坤逸地区工作生活的本地居民，到达Bunny Boy Massage体验曼谷变相按摩都非常方便。乘坐BTS轻轨到Phra Khanong站后步行仅需5分钟，乘坐出租车或Grab网约车也可直达门口。我们位于素坤逸最繁华的商业区，周边酒店、餐厅、购物中心林立，您可以在体验曼谷变相按摩前后轻松安排其他活动。如果您正在搜索"曼谷变相按摩"、"素坤逸变相按摩"或"曼谷Nuru按摩"，那么Bunny Boy Massage就是您的最佳答案——欢迎通过LINE或WhatsApp联系我们。',
    ],
  },
  ko: {
    what: [
      '방콕 짭까사이는 Bunny Boy Massage에서 제공하는 최고급 프리미엄 감각 마사지 경험입니다. 서비스에는 바디스크럽, 스파 핫터브 온센(월풀 바스), 아로마테라피 마사지, 카사이(전립선) 마사지가 포함됩니다. 방콕 짭까사이를 처음 경험하시는 분부터 재방문 고객까지, 모두가 만족할 수 있는 최고 수준의 서비스를 자부합니다. Bunny Boy Massage에서는 전문 교육을 이수한 20대 태국 마사지사가 방콕에서 가장 정통적인 방콕 짭까사이 경험을 제공합니다.',
      '다른 어떤 마사지 스타일과 달리, 방콕 짭까사이는 바디스크럽, 스파 핫터브 온센, 아로마테라피 마사지, 카사이 마사지를 하나의 완벽한 경험으로 결합합니다. 피부를 새롭게 하는 바디스크럽부터 근육을 풀어주는 스파 핫터브 온센, 프리미엄 오일을 사용한 아로마테라피 마사지, 그리고 깊은 만족감을 선사하는 카사이 마사지까지 — 이 독특한 조합이 방콕 짭까사이만의 독보적인 매력입니다.',
      'Bunny Boy Massage의 방콕 짭까사이가 특별한 이유는 품질에 대한 철저한 헌신입니다. 최고급 아로마 오일만 사용하며, 완벽한 스파 핫터브 온센 시설을 유지하고, 모든 방콕 짭까사이 마사지사들은 전문 집중 교육을 이수했습니다. 방콕 짭까사이를 찾는 한국인 고객에게 Bunny Boy Massage가 압도적 1위로 추천받는 이유가 바로 여기에 있습니다.',
    ],
    experience: [
      '방콕 짭까사이를 위해 Bunny Boy Massage에 도착하는 순간부터, 모든 디테일이 고객의 만족을 극대화하도록 정밀하게 설계되어 있습니다. 은은한 무드 조명과 부드러운 음악이 흐르는 리셉션에서 무료 웰컴 음료를 즐기시며, 엄선된 20대 마사지사 라인업을 직접 확인하고 선택하실 수 있습니다. 프라이빗 룸에는 편안한 마사지 베드, 레인폴 샤워, 분위기 있는 무드 조명, 개별 온도 조절 시스템이 완비되어 있습니다. 럭셔리 룸에는 전용 스파 핫터브 온센까지 구비되어 있습니다.',
      '럭셔리 룸 패키지의 방콕 짭까사이 세션은 스파 핫터브 온센에서의 따뜻한 입욕으로 시작됩니다. 월풀 제트가 근육의 긴장을 풀어주고 몸을 깊이 이완시킵니다. 90분 이상 세션에는 전문적인 바디스크럽이 포함되어, 각질을 제거하고 피부를 새롭게 합니다.',
      '아로마테라피 마사지는 프리미엄 에센셜 오일을 사용하여 전신의 긴장을 풀어주는 깊은 이완의 시간입니다. 세션은 카사이 마사지로 절정에 달하며, 깊은 만족감과 완전한 재충전의 느낌을 선사합니다.',
      'Bunny Boy Massage의 방콕 짭까사이는 단순한 마사지가 아닌, 시작부터 끝까지 완벽하게 설계된 프리미엄 감각 체험입니다. 많은 재방문 고객이 방콕 짭까사이를 매번 방콕 여행의 필수 코스로 꼽고 있습니다.',
    ],
    gel: [
      'Bunny Boy Massage 럭셔리 룸에 구비된 스파 핫터브 온센은 방콕 짭까사이 체험의 잊을 수 없는 하이라이트입니다. 일부 방콕 마사지 업소의 단순한 욕조와 달리, 저희 스파 핫터브 온센은 주요 근육군을 타겟으로 하는 강력한 수중 마사지 제트, 최적의 온도로 유지되는 따뜻한 순환 수류, 극대의 편안함을 위한 넉넉한 설계를 자랑합니다.',
      '마사지 전 스파 핫터브 온센에 몸을 담그면 모공이 열리고, 긴장된 근육이 이완되며, 이어지는 아로마테라피 마사지와 카사이 마사지를 위한 최적의 준비가 됩니다. 따뜻한 수류 순환이 혈액 순환을 촉진하고 긴장을 해소하여, 깊은 만족감을 주는 방콕 짭까사이 경험의 이상적인 토대를 마련합니다. 많은 재방문 고객이 스파 핫터브 온센만을 위해서라도 럭셔리 룸을 선택합니다.',
    ],
    steps: [
      { step: '01', title: '도착 & 방콕 짭까사이 마사지사 선택', desc: '방콕 짭까사이를 위해 Bunny Boy Massage에 도착하면 리셉션에서 따뜻하게 맞이하고 무료 웰컴 음료를 제공합니다. 라운지에서 엄선된 20대 아름다운 마사지사 라인업을 직접 보시고 마음에 드는 분을 선택하세요.' },
      { step: '02', title: '스파 핫터브 온센', desc: '럭셔리 룸 패키지에서는 스파 핫터브 온센에서의 따뜻한 입욕으로 시작됩니다. 월풀 제트가 근육의 긴장을 풀어주고 몸을 깊이 이완시켜, 이어질 서비스를 위한 완벽한 준비를 합니다.' },
      { step: '03', title: '바디스크럽', desc: '90분 이상 세션에는 전문적인 바디스크럽이 포함됩니다. 각질을 제거하고 혈액 순환을 촉진하여, 피부를 새롭게 하고 아로마테라피 마사지를 위한 최적의 상태를 만듭니다.' },
      { step: '04', title: '아로마테라피 & 카사이 마사지', desc: '방콕 짭까사이의 핵심 — 마사지사가 프리미엄 아로마 오일로 깊은 이완 마사지를 진행한 후, 카사이 마사지로 극대의 만족감과 완벽한 해소를 선사합니다.' },
      { step: '05', title: '상쾌한 마무리 & 애프터케어', desc: '방콕 짭까사이 세션 후 따뜻한 샤워로 상쾌하게 마무리합니다. 핫타올과 정성스러운 음료가 기다리며, 방콕 짭까사이의 여운을 편안하게 즐기시며 천천히 현실로 돌아올 수 있습니다.' },
    ],
    tips: [
      { icon: '🛁', text: '럭셔리 룸을 선택하여 스파 핫터브 온센을 즐기세요 — 월풀 바스는 방콕 짭까사이 경험의 완벽한 시작입니다.' },
      { icon: '💎', text: '방콕 짭까사이 세션 전 모든 주얼리와 시계를 제거하세요 — 바디스크럽과 마사지 과정에서 불편을 방지할 수 있습니다.' },
      { icon: '⏰', text: '방콕 짭까사이는 최소 30분 전에 예약하세요 — 사전 예약이 최고의 경험과 원하는 마사지사를 보장합니다.' },
      { icon: '🧴', text: '방콕 짭까사이 전 로션이나 바디 제품을 바르지 마세요 — 깨끗한 피부가 바디스크럽과 아로마테라피 마사지의 효과를 극대화합니다.' },
      { icon: '💧', text: '충분한 수분을 유지하세요 — 세션 전후에 충분히 물을 마시면 최상의 방콕 짭까사이 효과를 얻을 수 있습니다.' },
      { icon: '📱', text: 'LINE(bunnyboybkk)이나 WhatsApp(bunnyboybkk)으로 방콕 짭까사이를 미리 예약하여 선호하는 마사지사와 원하는 시간대를 확보하세요.' },
    ],
    location: [
      '수쿰빗에서 최고의 방콕 짭까사이를 찾는 것이 그 어느 때보다 쉬워졌습니다. Bunny Boy Massage는 수쿰빗 71 로드 3/15, 4층에 위치하며, BTS 프라카농역에서 도보 단 5분 거리입니다. 방콕의 주요 교통 허브에서 가장 가까운 방콕 짭까사이 전문 업소로, 호텔에서 택시나 Grab으로 쉽게 방문하실 수 있습니다. 4층의 프라이빗한 별도 입구로 방콕 짭까사이 고객의 완벽한 프라이버시를 보장합니다. 주변에 수쿰빗 최고의 호텔, 한식당, 일식당, 쇼핑몰이 밀집해 있어, 방콕 짭까사이 체험 전후로 식사나 쇼핑을 즐기기에도 최적의 위치입니다.',
    ],
  },
};

function NuruPage({ t, lang }) {
  const langAttr = lang === 'zh' ? 'zh-CN' : lang === 'ko' ? 'ko' : 'en';
  const prefix = lang === 'en' ? '' : `/${lang}`;
  const labels = sectionLabels[lang] || sectionLabels.en;
  const faqs = nuruFaqSchema[lang] || nuruFaqSchema.en;
  const body = bodyContent[lang] || bodyContent.en;
  const [openFaq, setOpenFaq] = useState(null);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };

  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Bunny Boy Massage",
    "description": "Premium Nuru massage parlor in Sukhumvit, Bangkok offering Body Scrub, Spa Hot Tub Onsen, Aromatherapy Massage and Kassai Massage",
    "url": "https://www.bunnyboymassage.com/nuru-massage-sukhumvit",
    "telephone": "+66811103766",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "3/15, 4th Floor, Sukhumvit 71 Rd",
      "addressLocality": "Phra Khanong Nuea, Watthana",
      "addressRegion": "Bangkok",
      "postalCode": "10110",
      "addressCountry": "TH"
    },
    "openingHours": "Mo-Su 10:00-00:00",
    "priceRange": "THB 2,000 - THB 3,700",
    "image": "/nuru-gallery-3.jpg"
  };

  return (
    <>
      <Helmet>
        <html lang={langAttr} />
        <meta name="google-site-verification" content="oqrrPJxHE-glI4a2-kLFEyROX0bIiQgU7FxBcaITmrA" />
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
        <meta name="keywords" content={t.meta.keywords} />
        <meta property="og:title" content={t.meta.title} />
        <meta property="og:description" content={t.meta.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://www.bunnyboymassage.com${prefix}/nuru-massage-sukhumvit`} />
        <meta property="og:image" content="https://www.bunnyboymassage.com/og-nuru.jpg" />
        <meta property="og:site_name" content="Bunny Boy Massage" />
        <meta property="og:locale" content={langAttr === 'zh-CN' ? 'zh_CN' : langAttr === 'ko' ? 'ko_KR' : 'en_US'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t.meta.title} />
        <meta name="twitter:description" content={t.meta.description} />
        <meta name="twitter:image" content="https://www.bunnyboymassage.com/og-nuru.jpg" />
        <link rel="canonical" href={`https://www.bunnyboymassage.com${prefix}/nuru-massage-sukhumvit`} />
        <link rel="alternate" hrefLang="en" href="https://www.bunnyboymassage.com/nuru-massage-sukhumvit" />
        <link rel="alternate" hrefLang="zh" href="https://www.bunnyboymassage.com/zh/nuru-massage-sukhumvit" />
        <link rel="alternate" hrefLang="ko" href="https://www.bunnyboymassage.com/ko/nuru-massage-sukhumvit" />
        <link rel="alternate" hrefLang="x-default" href="https://www.bunnyboymassage.com/nuru-massage-sukhumvit" />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessJsonLd)}</script>
      </Helmet>

      <section id="top" className="relative w-full overflow-hidden">
        <div className="hidden md:block relative w-full">
          <img src="/hero-nuru-pc.jpg" alt="Nuru Massage Sukhumvit Bangkok - Bunny Boy Massage" className="w-full h-auto block" style={{ minHeight: '400px', objectFit: 'cover' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0c0817]/60 via-[#0c0817]/30 to-[#0c0817]/80" />
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4">
            <p className="font-montserrat text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 fade-in" style={{ color: '#7bfcfe' }}>{t.hero.tagline}</p>
            <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold mb-4 slide-up" style={{ color: '#fd8bdb' }}>{t.hero.title}</h1>
            <p className="font-montserrat text-2xl md:text-3xl text-white/80 mb-10 italic fade-in" style={{ animationDelay: '0.3s' }}>{t.hero.subtitle}</p>
            <a href="#contact" className="font-montserrat text-sm tracking-widest uppercase border-2 px-10 py-4 transition-all duration-500 fade-in hover:bg-[#fd8bdb] hover:text-[#0c0817]" style={{ borderColor: '#fd8bdb', color: '#fd8bdb', animationDelay: '0.6s' }}>{t.hero.cta}</a>
          </div>
        </div>
        <div className="md:hidden relative w-full">
          <img src="/hero-nuru-mobile.jpg" alt="Nuru Massage Sukhumvit Bangkok" className="w-full h-auto block" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0c0817]/60 via-[#0c0817]/30 to-[#0c0817]/80" />
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4">
            <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-6 fade-in" style={{ color: '#7bfcfe' }}>{t.hero.tagline}</p>
            <h1 className="font-playfair text-4xl sm:text-5xl font-bold mb-4 slide-up" style={{ color: '#fd8bdb' }}>{t.hero.title}</h1>
            <p className="font-montserrat text-xl sm:text-2xl text-white/80 mb-10 italic fade-in" style={{ animationDelay: '0.3s' }}>{t.hero.subtitle}</p>
            <a href="#contact" className="font-montserrat text-sm tracking-widest uppercase border-2 px-10 py-4 transition-all duration-500 fade-in hover:bg-[#fd8bdb] hover:text-[#0c0817]" style={{ borderColor: '#fd8bdb', color: '#fd8bdb', animationDelay: '0.6s' }}>{t.hero.cta}</a>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse lg:flex-row items-stretch gap-10 lg:gap-14">
            <div className="w-full lg:w-1/2 flex items-center justify-center">
              <div className="w-full rounded-xl overflow-hidden shadow-2xl shadow-pink-900/30" style={{ border: '1px solid rgba(253,139,219,0.2)' }}>
                <video
                  src="/nuru-video-1.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px', maxHeight: '600px' }}
                />
              </div>
            </div>

            <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left">
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#7bfcfe' }}>{labels.guideSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold mb-8" style={{ color: '#fd8bdb' }}>{labels.guideTitle}</h2>
              <div className="w-24 h-px mb-10 lg:mx-0 mx-auto" style={{ background: 'linear-gradient(to right, #fd8bdb, #7bfcfe)' }} />
              <p className="font-montserrat text-lg sm:text-xl text-white/70 leading-relaxed mb-6">{t.about.description}</p>
              <p className="font-montserrat text-base sm:text-lg text-white/50 leading-relaxed italic mb-10">{t.about.description2}</p>

              <div>
                <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="inline-block font-montserrat text-sm tracking-widest uppercase px-12 py-5 transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/20" style={{ background: 'linear-gradient(135deg, #fd8bdb, #8673fb)', color: '#0c0817' }}>{t.cta.button}</a>
                <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center space-y-4 sm:space-y-0 sm:space-x-10 mt-8">
                  <a href="https://wa.me/66811103766" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
                    <img src="/icon-whatsapp.png" alt="WhatsApp" className="w-6 h-6 object-contain" />
                    <span className="font-montserrat text-sm">{t.cta.kakao}</span>
                  </a>
                  <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
                    <img src="/icon-line.png" alt="LINE" className="w-6 h-6 object-contain" />
                    <span className="font-montserrat text-sm">{t.cta.line}</span>
                  </a>
                  <a href="tel:081-110-3766" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
                    <svg className="w-6 h-6" style={{ color: '#fd8bdb' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                    <span className="font-montserrat text-sm">{t.cta.phone}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#8673fb' }}>{labels.guideSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.whatTitle}</h2>
              <div className="space-y-5">
                {body.what.map((p, i) => <p key={i} className="font-montserrat text-lg text-white/70 leading-relaxed">{p}</p>)}
              </div>
            </div>
            <div className="relative">
              <img src="/nuru-gallery-3.jpg" alt="Nuru Massage Sukhumvit - Premium Experience at Bunny Boy Massage" className="w-full h-auto rounded-lg shadow-2xl" style={{ border: '2px solid #fd8bdb40' }} />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full opacity-20 blur-2xl" style={{ background: '#7bfcfe' }} />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <img src="/nuru-gallery-2.jpg" alt="Nuru Massage Session Sukhumvit Bangkok" className="w-full h-auto rounded-lg shadow-2xl" style={{ border: '2px solid #7bfcfe40' }} />
            </div>
            <div className="order-1 lg:order-2">
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#7bfcfe' }}>{labels.experienceSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.experienceTitle}</h2>
              <div className="space-y-5">
                {body.experience.map((p, i) => <p key={i} className="font-montserrat text-lg text-white/70 leading-relaxed">{p}</p>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#fd8bdb' }}>{labels.gelSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.gelTitle}</h2>
              <div className="space-y-5">
                {body.gel.map((p, i) => <p key={i} className="font-montserrat text-lg text-white/70 leading-relaxed">{p}</p>)}
              </div>
            </div>
            <div className="relative">
              <img src="/nuru-gallery-5.jpg" alt="Authentic Nuru Gel Massage Experience Sukhumvit" className="w-full h-auto rounded-lg shadow-2xl" style={{ border: '2px solid #8673fb40' }} />
              <div className="absolute -top-4 -left-4 w-32 h-32 rounded-full opacity-15 blur-3xl" style={{ background: '#fd8bdb' }} />
            </div>
          </div>
        </div>
      </section>

      <GallerySection title={labels.galleryTitle} subtitle={labels.gallerySubtitle} images={galleryImages} />

      <section className="py-16 sm:py-24 bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#7bfcfe' }}>{labels.typesSubtitle}</p>
            <h2 className="font-playfair text-4xl sm:text-5xl font-bold text-white">{labels.typesTitle}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {t.services.items.map((item, i) => {
              const colors = ['#fd8bdb', '#7bfcfe', '#8673fb'];
              return (
                <div key={i} className="p-8 rounded-lg transition-all duration-500 hover:translate-y-[-4px] hover:shadow-lg" style={{ background: '#0e0a1a', border: `1px solid ${colors[i]}40` }}>
                  <h3 className="font-playfair text-2xl mb-6" style={{ color: colors[i] }}>{item.title}</h3>
                  <p className="font-montserrat text-lg text-white/60 leading-relaxed">{item.description}</p>
                  <div className="mt-8 h-px" style={{ background: `linear-gradient(to right, ${colors[i]}60, transparent)` }} />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <PriceTable title={labels.priceTitle} subtitle={labels.priceSubtitle} priceData={lang === 'zh' ? priceDataZh : priceData} />

      <WhySection title={t.why.title} items={t.why.items} />

      <ManagerSection title={labels.managerTitle} titleColor="#b299fa" subtitle={labels.managerSubtitle} subtitleColor="#9f87e4" managers={managers} />

      <section className="py-16 sm:py-24 bg-dark-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#8673fb' }}>{labels.expectSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-8" style={{ color: '#fd8bdb' }}>{labels.expectTitle}</h2>
              <div className="space-y-6">
                {body.steps.map((item, i) => (
                  <div key={i} className="flex items-start space-x-4">
                    <span className="font-playfair text-2xl font-bold flex-shrink-0 w-10" style={{ color: '#7bfcfe' }}>{item.step}</span>
                    <div>
                      <h4 className="font-montserrat text-lg font-semibold text-white mb-1">{item.title}</h4>
                      <p className="font-montserrat text-white/60 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <img src="/nuru-gallery-1.jpg" alt="Nuru Massage Experience Sukhumvit" className="w-full h-auto rounded-lg shadow-2xl" style={{ border: '2px solid #7bfcfe40' }} />
              <div className="absolute -top-4 -left-4 w-32 h-32 rounded-full opacity-15 blur-3xl" style={{ background: '#8673fb' }} />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.tipsTitle}</h2>
            <div className="w-24 h-px mx-auto mb-10" style={{ background: 'linear-gradient(to right, #7bfcfe, #fd8bdb)' }} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {body.tips.map((tip, i) => (
              <div key={i} className="flex items-start space-x-4 p-5 rounded-lg" style={{ background: '#110b1f' }}>
                <span className="text-2xl flex-shrink-0">{tip.icon}</span>
                <p className="font-montserrat text-white/70 leading-relaxed">{tip.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative">
              <img src="/nuru-gallery-4.jpg" alt="Premium Nuru Massage Room Sukhumvit Bangkok" className="w-full h-auto rounded-lg shadow-2xl" style={{ border: '2px solid #8673fb40' }} />
            </div>
            <div>
              <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#7bfcfe' }}>{labels.locationSubtitle}</p>
              <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.locationTitle}</h2>
              <div className="space-y-5">
                {body.location.map((p, i) => <p key={i} className="font-montserrat text-lg text-white/70 leading-relaxed">{p}</p>)}
                <div className="space-y-3 mt-6">
                  <div className="flex items-start space-x-3">
                    <span style={{ color: '#fd8bdb' }}>📍</span>
                    <p className="font-montserrat text-white/70">3/15, 4th Floor, Sukhumvit 71 Rd, Khwaeng Phra Khanong Nuea, Watthana, Bangkok 10110</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <span style={{ color: '#7bfcfe' }}>🕐</span>
                    <p className="font-montserrat text-white/70">Open Daily: 10:00 AM — 00:00 AM</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <span style={{ color: '#8673fb' }}>🚇</span>
                    <p className="font-montserrat text-white/70">5-minute walk from BTS Phra Khanong Station</p>
                  </div>
                </div>
              </div>
              <div className="mt-8 w-full h-[250px] rounded-lg overflow-hidden" style={{ border: '1px solid #fd8bdb30' }}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.8!2d100.5936575!3d13.7141704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29fc1448bad8b%3A0x783ac84a11658233!2sBunny%20Boy%20Massage!5e0!3m2!1sen!2sth!4v1234567890" width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Bunny Boy Massage Nuru Massage Sukhumvit Location" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="font-montserrat text-xs tracking-[0.3em] uppercase mb-4" style={{ color: '#8673fb' }}>{labels.faqSubtitle}</p>
            <h2 className="font-playfair text-4xl sm:text-5xl font-bold" style={{ color: '#fd8bdb' }}>{labels.faqTitle}</h2>
          </div>
          <div className="space-y-3">
            {faqs.map((item, i) => (
              <div key={i} className="rounded-lg transition-all duration-300" style={{ border: `1px solid ${openFaq === i ? '#fd8bdb60' : '#fd8bdb20'}`, background: openFaq === i ? '#110b1f' : 'transparent' }}>
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex justify-between items-center p-5 text-left cursor-pointer" aria-expanded={openFaq === i} aria-controls={`nuru-faq-${i}`}>
                  <span className="font-montserrat text-lg sm:text-xl text-white pr-4">{item.q}</span>
                  <span className="text-2xl flex-shrink-0" style={{ color: '#fd8bdb' }}>{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && (
                  <div id={`nuru-faq-${i}`} className="px-5 pb-5">
                    <p className="font-montserrat text-lg text-white/60 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="py-24 sm:py-32 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #110b1f 0%, #0c0817 100%)' }}>
        <div className="absolute inset-0 bg-gradient-to-br from-pink-900/10 via-transparent to-purple-900/10" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full opacity-5 blur-3xl" style={{ background: '#fd8bdb' }} />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-playfair text-4xl sm:text-5xl font-bold mb-6" style={{ color: '#fd8bdb' }}>{labels.ctaTitle}</h2>
          <p className="font-montserrat text-xl text-white/60 mb-12 leading-relaxed">{labels.ctaSubtitle}</p>
          <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="inline-block font-montserrat text-sm tracking-widest uppercase px-12 py-5 transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/30" style={{ background: 'linear-gradient(135deg, #fd8bdb, #8673fb)', color: '#0c0817' }}>{labels.ctaButton}</a>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-10 mt-10">
            <a href="https://wa.me/66811103766" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
              <img src="/icon-whatsapp.png" alt="WhatsApp" className="w-6 h-6 object-contain" />
              <span className="font-montserrat text-sm">{t.cta.kakao}</span>
            </a>
            <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
              <img src="/icon-line.png" alt="LINE" className="w-6 h-6 object-contain" />
              <span className="font-montserrat text-sm">{t.cta.line}</span>
            </a>
            <a href="tel:081-110-3766" className="flex items-center space-x-3 text-white/60 hover:text-white transition-colors">
              <svg className="w-6 h-6" style={{ color: '#fd8bdb' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              <span className="font-montserrat text-sm">{t.cta.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default NuruPage;
